function updateIframe() {
  const input = document.getElementById("awbInput").value.trim();
  if (!input) return alert("Please enter an Order ID or AWB tracking number");

  if (!input.toUpperCase().startsWith("LB")) {
    document.querySelector(".custom-track--order-message").style.display = "block";
    document.querySelector(".custom-track--order-message").textContent = "Invalid tracking ID";
    return;
  }

  fetch(`https://bluedart.marmeto.com/api/order_number/${input}?store=beauty`)
    .then(res => res.json())
    .then(result => {
      console.log("result", result)
      let shipment;
      if (result?.data?.ShipmentData) {
        shipment = result.data.ShipmentData[0];
        console.log("if staement executed")
        const message = result?.message;
        if (message && !result?.data) {
          document.querySelector(".custom-track--order-message").style.display = "block";
          document.querySelector(".custom-track--order-message").textContent = `${message}`;
          document.querySelector(".custom-track-order-wrapper").style.display = "none";
          return;
        }
        if (shipment === undefined) {
          document.querySelector(".custom-track--order-message").textContent = "Invalid Order Id";
          return;
        }

        document.querySelector(".custom-track-order-wrapper").style.display = "block";
        document.querySelector(".custom-track--order-message").style.display = "none";

        const scans = shipment.Shipment.Scans || [];
        const status = shipment.Shipment.Status.Status || "";
        const eta = shipment.Shipment.ExpectedDeliveryDate || "";
        const pickupDate = result.order_date;
        const trackingUrl = result?.tracking_url;
        const linkElement = document.querySelector('.tracking_url_container');

        if (linkElement) {
          linkElement.href = trackingUrl;
        }

        const steps = document.querySelectorAll(".delivery_status__step");
        const rtoStep = document.querySelector('.delivery_status__step.rto');
        const rtoStepText = document.querySelector('.delivery_status__status.rto');
        rtoStep.style.display = "none";
        steps.forEach(step => step.classList.remove("completed"));

        // Step 1: Order Confirmed
        steps[0]?.classList.add("completed");

        let isInTransit = false;
        let isOutForDelivery = false;

        scans.forEach(s => {
          const scanText = s?.ScanDetail?.Instructions?.toLowerCase() || "";
          if (scanText.includes("arrived") || scanText.includes("picked up") || scanText.includes("connected")) {
            isInTransit = true;
          }
          if (scanText.includes("out for delivery")) {
            isOutForDelivery = true;
          }
        });

        if (isInTransit || isOutForDelivery || status.toLowerCase().includes("delivered")) {
          steps[1]?.classList.add("completed"); // In Transit
        }

        if (isOutForDelivery || status.toLowerCase().includes("delivered")) {
          steps[2]?.classList.add("completed"); // Out for Delivery
        }

        if (status.toLowerCase().includes("delivered")) {
          steps[3]?.classList.add("completed"); // Delivered
        }

        // Get the last completed step's text as status
        let statusText = "Order Confirmed";
        const completedSteps = Array.from(steps).filter(step => step.classList.contains("completed"));
        if (completedSteps.length > 0) {
          statusText = completedSteps[completedSteps.length - 1].textContent.trim();
        }


        // Handle delivery ETA display
        const deliveryWrapper = document.querySelector(".custom-track-order-delivery-wrapper");
        if (statusText === "Order delivered" || !eta) {
          deliveryWrapper.style.display = "none";
          document.querySelector(".to-delivery-status").textContent = statusText;
        } else {
          const etaDate = new Date(eta);
          document.querySelector(".to-delivery-date").textContent = etaDate.getDate();
          document.querySelector(".to-delivery-month").textContent = etaDate.toLocaleString('default', { month: 'long' });
          document.querySelector(".to-deliver-year").textContent = etaDate.getFullYear();
          document.querySelector(".to-delivery-status").textContent = statusText;
          deliveryWrapper.style.display = "block";
        }

        document.querySelector(".order-id-display").textContent = input;
        document.querySelector(".pickup-date-display").textContent = formatDate(pickupDate);
      }
      // else {
      //   shipment = result.data.tracking_data;
      //   console.log("else consition executed shipment", shipment);
      //   const message = result?.message;
      //   if (message && !result?.data) {
      //     document.querySelector(".custom-track--order-message").style.display = "block";
      //     document.querySelector(".custom-track--order-message").textContent = `${message}`;
      //     document.querySelector(".custom-track-order-wrapper").style.display = "none";
      //     return;
      //   }
      //   if (shipment === undefined) {
      //     document.querySelector(".custom-track--order-message").textContent = "Invalid Order Id";
      //     return;
      //   }

      //   document.querySelector(".custom-track-order-wrapper").style.display = "block";
      //   document.querySelector(".custom-track--order-message").style.display = "none";

      //   const scans = shipment.shipment_track_activities[0] || [];
      //   const status = shipment.shipment_track_activities.activity || "";
      //   const eta = shipment.etd || "";
      //   const pickupDate = shipment.Shipment.PickUpDate || shipment.Shipment.StatusDate;
      //   const trackingUrl = result?.tracking_url;
      //   console.log("trackingUrl", trackingUrl);
      //   const linkElement = document.querySelector('.tracking_url_container');

      //   if (linkElement) {
      //     linkElement.href = trackingUrl;
      //   }

      //   const steps = document.querySelectorAll(".delivery_status__step");
      //   steps.forEach(step => step.classList.remove("completed"));

      //   // Step 1: Order Confirmed
      //   steps[0]?.classList.add("completed");

      //   let isInTransit = false;
      //   let isOutForDelivery = false;

      //   scans.forEach(s => {
      //     const scanText = s?.ScanDetail?.Instructions?.toLowerCase() || "";
      //     if (scanText.includes("arrived") || scanText.includes("picked up") || scanText.includes("connected")) {
      //       isInTransit = true;
      //     }
      //     if (scanText.includes("out for delivery")) {
      //       isOutForDelivery = true;
      //     }
      //   });

      //   if (isInTransit || isOutForDelivery || status.toLowerCase().includes("delivered")) {
      //     steps[1]?.classList.add("completed"); // In Transit
      //   }

      //   if (isOutForDelivery || status.toLowerCase().includes("delivered")) {
      //     steps[2]?.classList.add("completed"); // Out for Delivery
      //   }

      //   if (status.toLowerCase().includes("delivered")) {
      //     steps[3]?.classList.add("completed"); // Delivered
      //   }

      //   // Get the last completed step's text as status
      //   let statusText = "Order Confirmed";
      //   const completedSteps = Array.from(steps).filter(step => step.classList.contains("completed"));
      //   if (completedSteps.length > 0) {
      //     statusText = completedSteps[completedSteps.length - 1].textContent.trim();
      //   }


      //   // Handle delivery ETA display
      //   const deliveryWrapper = document.querySelector(".custom-track-order-delivery-wrapper");
      //   if (statusText === "Order delivered" || !eta) {
      //     deliveryWrapper.style.display = "none";
      //     document.querySelector(".to-delivery-status").textContent = statusText;
      //   } else {
      //     const etaDate = new Date(eta);
      //     document.querySelector(".to-delivery-date").textContent = etaDate.getDate();
      //     document.querySelector(".to-delivery-month").textContent = etaDate.toLocaleString('default', { month: 'long' });
      //     document.querySelector(".to-deliver-year").textContent = etaDate.getFullYear();
      //     document.querySelector(".to-delivery-status").textContent = statusText;
      //     deliveryWrapper.style.display = "block";
      //   }

      //   document.querySelector(".order-id-display").textContent = input;
      //   document.querySelector(".pickup-date-display").textContent = formatDate(pickupDate);
      // }
      // const shipment = result?.data?.ShipmentData?.[0];

      else {
        const shipment = result?.data?.tracking_data;

        console.log("shipment", shipment);

        const message = result?.message;

        // Handle invalid response
        if (message && !result?.data) {
          document.querySelector(".custom-track--order-message").style.display = "block";
          document.querySelector(".custom-track--order-message").textContent = message;
          document.querySelector(".custom-track-order-wrapper").style.display = "none";
          return;
        }

        if (!shipment) {
          document.querySelector(".custom-track--order-message").style.display = "block";
          document.querySelector(".custom-track--order-message").textContent = "Invalid Order Id";
          document.querySelector(".custom-track-order-wrapper").style.display = "none";
          return;
        }

        document.querySelector(".custom-track-order-wrapper").style.display = "block";
        document.querySelector(".custom-track--order-message").style.display = "none";

        // Activities Array
        const activities = shipment?.shipment_track_activities || [];

        // Latest tracking object
        const latestTrack = shipment?.shipment_track?.[0] || {};

        // Current Status
        const currentStatus = latestTrack?.current_status || "";

        let isRTO = currentStatus.toLowerCase().includes("rto");

        document.querySelector(".to-delivery-status").textContent = currentStatus;

        // ETA
        const eta = shipment?.etd || "";

        // Pickup Date
        const pickupDate = result.order_date;

        // Tracking URL
        const trackingUrl = result?.tracking_url || shipment?.track_url || "";

        console.log("trackingUrl", trackingUrl);

        const linkElement = document.querySelector(".tracking_url_container");

        if (linkElement && trackingUrl) {
          linkElement.href = trackingUrl;
        }

        // Reset steps
        const steps = document.querySelectorAll(".delivery_status__step");

        const rtoStep = document.querySelector('.delivery_status__step.rto');

        const rtoStepText = document.querySelector('.delivery_status__status.rto');

        rtoStep.style.display = "none";

        steps.forEach(step => step.classList.remove("completed"));

        // Step 1: Order Confirmed
        steps[0]?.classList.add("completed");

        let isInTransit = false;
        let isOutForDelivery = false;
        let isDelivered = false;
        let isUndelivered = false;

        if (currentStatus.toLowerCase().includes("undelivered")) {
          isUndelivered = true;
        }

        const undeliveredReason =
          shipment?.ndr?.reason ||
          "Undelivered";

        // activities.forEach(activity => {
        //   const activityText = activity?.activity?.toLowerCase() || "";
        //   const statusLabel = activity?.["sr-status-label"]?.toLowerCase() || "";

        //   // In Transit
        //   if (
        //     activityText.includes("intransit") ||
        //     activityText.includes("shipment added in bag") ||
        //     statusLabel.includes("in transit") ||
        //     statusLabel.includes("reached at destination hub")
        //   ) {
        //     isInTransit = true;
        //   }

        //   // Out For Delivery
        //   if (
        //     activityText.includes("out for delivery") ||
        //     statusLabel.includes("out for delivery")
        //   ) {
        //     isOutForDelivery = true;
        //   }

        //   // Delivered
        //   if (
        //     activityText.includes("delivered") ||
        //     statusLabel.includes("delivered")
        //   ) {
        //     isDelivered = true;
        //   }
        // });

        const latestActivity = activities?.[0] || {};
const latestStatusLabel =
  latestActivity?.["sr-status-label"]?.toLowerCase() || "";

        activities.forEach(activity => {
          const activityText = activity?.activity?.toLowerCase() || "";
          const statusLabel = activity?.["sr-status-label"]?.toLowerCase() || "";

          if (latestStatusLabel === "delivered") {
  isDelivered = true;
  isUndelivered = false;
  isRTO = false;
}
else if (latestStatusLabel === "undelivered") {
  isUndelivered = true;
}

          if (
            statusLabel.includes("rto") ||
            activityText.includes("return") ||
            activityText.includes("rto")
          ) {
            isRTO = true;
          }

          if (
            statusLabel.includes("undelivered") ||
            activity?.status?.toLowerCase().includes("undelivered") ||
            activityText.includes("customer not responding") ||
            activityText.includes("reschedule") ||
            activityText.includes("undelivered")
          ) {
            isUndelivered = true;
          }

          if (
            statusLabel.includes("in transit") ||
            activityText.includes("shipment received at facility") ||
            activityText.includes("bag received") ||
            activityText.includes("trip arrived")
          ) {
            isInTransit = true;
          }

          if (
            statusLabel.includes("out for delivery") ||
            activityText.includes("out for delivery")
          ) {
            isOutForDelivery = true;
          }

          if (
            statusLabel.includes("delivered") ||
            activityText.includes("delivered")
          ) {
            isDelivered = true;
          }
        });

        const statusContainer = document.querySelector(
          ".delivery_tracking__status_container"
        );
        const dateContainer = document.querySelector(".custom-track-order-delivery-wrapper");

        if (isRTO || isUndelivered) {
          // statusContainer.style.display = "none";
          dateContainer.style.display = "none";
        } else {
          statusContainer.style.display = "block";
          dateContainer.style.display = "block";
        }

        if (isRTO){
          rtoStep.style.display = "flex";
          rtoStep.classList.add('completed');
          rtoStepText.textContent = currentStatus ;
        }

        console.log("isRTO", isRTO);

        // Step 2: In Transit
        if (isInTransit || isOutForDelivery || isDelivered) {
          steps[1]?.classList.add("completed");
        }

        // Step 3: Out For Delivery
        if (isOutForDelivery || isDelivered) {
          steps[2]?.classList.add("completed");
        }

        // Step 4: Delivered
        if (isDelivered || currentStatus.toLowerCase().includes("delivered")) {
          steps[3]?.classList.add("completed");
          steps[3].querySelector('.delivery_status__status').textContent = 'Order delivered';
        }

        if (isUndelivered){
          steps[3].querySelector('.delivery_status__status').textContent = 'Order undelivered';
        }

        // Get latest completed step text
        let statusText = "Order Confirmed";

        if (isRTO) {
          statusText = 'Return to origin';
        }
        else if (isUndelivered) {
          statusText = 'Undelivered';
        }  
        else {
          console.log("steps", steps);
          const completedSteps = Array.from(steps).filter(step =>
            step.classList.contains("completed")
          );

          console.log("completedSteps", completedSteps);

          if (completedSteps.length > 0) {
            console.log("else if");
            statusText =
              completedSteps[completedSteps.length - 1].textContent.trim();
              console.log("statusText", statusText);
          }
        

        }


        // const completedSteps = Array.from(steps).filter(step =>
        //   step.classList.contains("completed")
        // );

        // if (completedSteps.length > 0) {
        //   statusText =
        //     completedSteps[completedSteps.length - 1].textContent.trim();
        // }

        // Delivery ETA handling
        const deliveryWrapper = document.querySelector(
          ".custom-track-order-delivery-wrapper"
        );

        if (
          statusText.toLowerCase().includes("delivered") ||
          isUndelivered ||
          isRTO ||
          !eta
        ) {
          deliveryWrapper.style.display = "none";

          document.querySelector(".to-delivery-status").textContent =
            statusText;
        } else {
          const etaDate = new Date(eta);

          document.querySelector(".to-delivery-date").textContent =
            etaDate.getDate();

          document.querySelector(".to-delivery-month").textContent =
            etaDate.toLocaleString("default", { month: "long" });

          document.querySelector(".to-deliver-year").textContent =
            etaDate.getFullYear();

          document.querySelector(".to-delivery-status").innerHTML =
            statusText;

          deliveryWrapper.style.display = "block";
        }

        console.log("statusText", statusText);
        console.log("currentStatus", currentStatus);

        // Order ID
        document.querySelector(".order-id-display").textContent = input;

        // Pickup Date
        document.querySelector(".pickup-date-display").textContent =
          formatDate(pickupDate);
      }
    })
    .catch(err => {
      console.error("Error fetching shipment data:", err);
    });
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}
